import { DefaultRequest } from 'scripts/api';

Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.Telematic = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          attributes: {
            class: 'control-group',
            id: 'telematicProvider',
          },
        },
        {
          attributes: {
            class: 'control-group',
            id: 'telematicValues',
          },
        },
      ],
    };
  },

  assignParameter(jsonParam) {
    const createGrowList = () => {
      const gpsProviderContainer = document.querySelector('#Event #telematicProvider');
      const gpsValuesContainer = document.querySelector('#Event #telematicValues');

      const gpsProvider = new Monet.UI.Fields.PickList();
      gpsProvider.setLookUpEntity('GPSProvider');
      gpsProvider.setDisplayKey('description');
      gpsProvider.createBaseStructure();
      gpsProvider.setTextLabel(Monet.I18n.getResourcesByKey('telematic.gps.provider'));
      gpsProvider.rootEl.setAttribute('class', 'MonetUIFieldPicker');

      const gpsProviderEl = gpsProvider.render();
      gpsProvider.input.addEventListener('change', () => { growList.clear(); });

      if (jsonParam) {
        gpsProvider.setValue({ id: jsonParam.gpsProvider });
      }

      const defaultCriteriaForFields = {
        criteriaChain: [{
          and: [
            { attr: 'description', matchMode: 'ANYWHERE' },
            { attr: 'gpsProvider.id' },
          ],
        }],
      };

      const selectOptions = {

        '>=': 'GREATER_OR_EQUALS',
        '>': 'GREATER',
        '=': 'EQUALS',
        '<=': 'LESS_OR_EQUALS',
        '<': 'LESS',

      };

      const dataSource = {

        numberOfItemsForGrowList: () => jsonParam ? jsonParam.assertions.length : 0,

        cssClassForRowAtIndexForGrowList: () => 'telematicValue',

        cellForRowAtIndexForGrowList: (index) => {
          const valueContainer = document.createElement('div');
          defaultCriteriaForFields.criteriaChain[0].and[1].eq = gpsProvider.getValue();

          const telematicProperty = new Monet.UI.Fields.PowerLookup();
          telematicProperty.setNameSpace('GPSProviderTelematicProp');
          telematicProperty.setBaseSelector('.telematicValue');
          telematicProperty.setLookUpEntity('GPSProviderTelematicProp');
          telematicProperty.setRequestFilter('/restrictions?criteria={"filters":["*"]}');
          telematicProperty.setDisplayKey('description');
          telematicProperty.setRequestBody(defaultCriteriaForFields);
          telematicProperty.rootEl.setAttribute('class', 'MonetUIFieldPicker');

          const telematicPropertyEl = telematicProperty.render();
          telematicProperty.setValue({
            id: jsonParam.assertions[index].gpsProviderTelematicPropId,
            description: jsonParam.assertions[index].gpsProviderTelematicPropDescription,

          });

          const assertSelect = document.createElement('select');

          for (const option in selectOptions) {
            const selectOption = document.createElement('option');
            selectOption.value = selectOptions[option];
            selectOption.innerHTML = option;

            if (jsonParam) {
              const operator = jsonParam.assertions[index].operator;

              if (operator === selectOptions[option]) {
                selectOption.selected = true;
              }
            }

            assertSelect.appendChild(selectOption);
          }

          const numberInput = new Monet.UI.Fields.Number();
          numberInput.setOptions({ allowNegative: true });
          numberInput.setValue(jsonParam.assertions[index].value);

          valueContainer.appendChild(telematicPropertyEl);
          valueContainer.appendChild(assertSelect);
          valueContainer.appendChild(numberInput.render());

          return valueContainer;
        },

      };

      const delegate = {

        shouldCreateNewCell: () => !!gpsProvider.getValue(),

        createNewCell: () => {
          const valueContainer = document.createElement('div');
          defaultCriteriaForFields.criteriaChain[0].and[1].eq = gpsProvider.getValue().id;

          const telematicProperty = new Monet.UI.Fields.PowerLookup();
          telematicProperty.setNameSpace('GPSProviderTelematicProp');
          telematicProperty.setLookUpEntity('GPSProviderTelematicProp');
          telematicProperty.setRequestFilter('/restrictions?criteria={"filters":["*"]}');
          telematicProperty.setDisplayKey('description');
          telematicProperty.setRequestBody(defaultCriteriaForFields);
          telematicProperty.rootEl.setAttribute('class', 'MonetUIFieldPicker');

          const assertSelect = document.createElement('select');

          for (const option in selectOptions) {
            const selectOption = document.createElement('option');
            selectOption.value = selectOptions[option];
            selectOption.innerHTML = option;

            assertSelect.appendChild(selectOption);
          }

          const numberInput = new Monet.UI.Fields.Number();
          numberInput.setOptions({ allowNegative: true });
          valueContainer.appendChild(telematicProperty.render());
          valueContainer.appendChild(assertSelect);
          valueContainer.appendChild(numberInput.render());

          return valueContainer;
        },

        cssClassForNewCell() {
          return 'telematicValue';
        },

        shouldRemoveCellAtIndex: () => true,

      };

      let growList = new Monet.UI.Fields.GrowList();
      growList.dataSource = dataSource;
      growList.delegate = delegate;

      growList.setCallBackAfterAction(function () {
        const numberOfDivs = this.querySelectorAll('.telematicValue');
        if (numberOfDivs.length) {
          this.style.height = `${numberOfDivs.length * 33}px`;
        } else {
          this.style.height = `${33}px`;
        }
      }.bind(gpsValuesContainer));

      gpsValuesContainer.appendChild(growList.render());
      gpsProviderContainer.appendChild(gpsProviderEl);

      const numberOfDivs = gpsValuesContainer.querySelectorAll('.telematicValue');
      if (numberOfDivs.length) {
        gpsValuesContainer.style.height = `${numberOfDivs.length * 33}px`;
      } else {
        gpsValuesContainer.style.height = `${33}px`;
      }
    };


    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);

      const criteria = {
        criteriaChain: [{
          and: [
            { attr: 'gpsProvider.id', eq: jsonParam.gpsProvider },
            { attr: 'enabled', eq: true },
          ],
        }],
      };

      const request = new DefaultRequest({
        url: 'GPSProviderTelematicProp/restrictions?criteria={"filters": ["*"]}',
        method: 'post',
        data: criteria,
        success(data) {
          if (jsonParam.assertions && data) {
            for (let i = 0; i < jsonParam.assertions.length; i++) {
              for (let j = 0; j < data.length; j++) {
                if (jsonParam.assertions[i].gpsProviderTelematicPropId === data[j].id.toString()) {
                  jsonParam.assertions[i].gpsProviderTelematicPropDescription = data[j].description;
                }
              }
            }
          }

          createGrowList();
        },
      });
      request.send();
    } else {
      createGrowList();
    }
  },

  retrieveParameter() {
    const telematicProvider = document.querySelector('#Event #telematicProvider select');
    const telematicValues = document.querySelectorAll('#Event #telematicValues .telematicValue');

    const jsonValues = {

      gpsProvider: telematicProvider.value,
      assertions: [],

    };

    for (let i = 0; i < telematicValues.length; i++) {
      const telematicElement = telematicValues[i];

      jsonValues.assertions[i] = {

        gpsProviderTelematicPropId: telematicElement.querySelector('.MonetUIFieldPicker input[type="hidden"]').value,
        operator: telematicElement.querySelector('select').value,
        value: telematicElement.querySelector('.stepper-wrap input').value,

      };
    }

    return JSON.stringify(jsonValues);
  },
};
